import { render, staticRenderFns } from "./activity_logs.vue?vue&type=template&id=0feed7f8"
import script from "./activity_logs.vue?vue&type=script&lang=js"
export * from "./activity_logs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports